import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Reveal, Overline } from "./Reveal";
import { CONTACT } from "@/lib/content";

export const PrivacyPage = () => {
  useEffect(() => {
    document.title = "Política de Privacidade | Melo Agro Engenharia";
  }, []);

  return (
    <main data-testid="privacy-page" className="pt-[72px]">
      <section className="mx-auto max-w-[820px] px-5 py-16 sm:px-8 md:py-24">
        <Reveal><Overline>LGPD</Overline></Reveal>
        <h1 className="mt-6 font-serif text-4xl font-semibold tracking-tight text-[#1A2218] sm:text-5xl">Política de Privacidade</h1>
        <div className="mt-10 space-y-8 text-base leading-relaxed text-[#2C332A]">
          <section>
            <h2 className="font-serif text-2xl text-[#1A2218]">Quem somos</h2>
            <p className="mt-3">
              Melo Agro Engenharia Ltda. (CNPJ 40.832.207/0001-47), sediada na Rua Santos Dumont, 324 — Pelotas/RS, é a responsável pelo tratamento
              dos dados pessoais coletados neste site.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#1A2218]">Quais dados coletamos</h2>
            <ul className="mt-3 list-disc space-y-2 pl-5">
              <li>Dados que você informa nos formulários: nome, e-mail, telefone/WhatsApp, município e a mensagem que você escreve.</li>
              <li>O serviço de interesse e o seu perfil (produtor rural, advogado(a), banco ou cooperativa), quando você seleciona.</li>
              <li>Dados de navegação de forma anônima e agregada (páginas visitadas, cliques), quando as métricas do site estão ativadas.</li>
            </ul>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#1A2218]">Para que usamos</h2>
            <p className="mt-3">
              Exclusivamente para retornar o seu contato, preparar orçamentos, prestar os serviços solicitados e enviar o material que você pediu.
              Não vendemos, alugamos ou compartilhamos seus dados com terceiros para fins de marketing.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#1A2218]">Por quanto tempo guardamos</h2>
            <p className="mt-3">Mantemos os dados pelo tempo necessário para atender à sua solicitação e cumprir obrigações legais. Você pode pedir a exclusão a qualquer momento.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#1A2218]">Cookies</h2>
            <p className="mt-3">
              Usamos cookies essenciais para o funcionamento do site. Ferramentas de medição de audiência, como o Google Analytics (por meio do
              Google Tag Manager), só são carregadas após você aceitar o aviso de cookies — enquanto isso, a medição permanece desativada
              (Google Consent Mode). Quando ativa, a medição é feita de forma agregada e anônima. Você pode limpar os cookies do navegador a
              qualquer momento.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#1A2218]">Seus direitos (LGPD)</h2>
            <p className="mt-3">
              Você pode solicitar a confirmação de tratamento, acesso, correção, portabilidade, anonimização ou eliminação dos seus dados, e revogar o
              consentimento quando aplicável.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#1A2218]">Contato</h2>
            <p className="mt-3">
              Para exercer seus direitos ou tirar dúvidas sobre esta política, fale com a gente:{" "}
              <a href={`mailto:${CONTACT.email}`} className="font-semibold text-[#233D25] underline underline-offset-2">{CONTACT.email}</a> ou WhatsApp{" "}
              <a href={`tel:+${CONTACT.wa}`} className="font-semibold text-[#233D25] underline underline-offset-2">{CONTACT.phone}</a>.
            </p>
          </section>
          <p className="border-t border-[#E5E0D5] pt-6 text-sm text-[#4A5549]">
            Última atualização: outubro de 2026. <Link to="/" className="underline underline-offset-2">Voltar ao início</Link>
          </p>
        </div>
      </section>
    </main>
  );
};
